import { MealPreferencesService } from "@/clients/services/MealPreferencesService";
import { QueryKeys } from "@/constants/query-keys";
import { useQuery } from "@tanstack/react-query";

export const useGetFoodAvoidOptions = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.FOOD_AVOID_OPTIONS],
    queryFn: async () => {
      const { data } =
        await MealPreferencesService.getAvoidPreferenceOptionsApiV1MealPreferencesAvoidsOptionsGet();
      return data;
    },
  });

  return {
    data,
    isLoading,
    isError,
    error,
  };
};
